import { Skeleton } from "../../../components/ui/skeleton"
import { Card, CardContent } from "../../../components/ui/card"

export default function InitialInformationSkeleton() {
  return (
    <div className="space-y-6 bg-white min-h-[calc(100vh-(160px+3.125em))] flex flex-col items-center justify-start h-full p-4 w-full">
      <div className="flex justify-end w-full">
        <Skeleton className="h-10 w-44 rounded-sm" />
      </div>
      {/* Stepper */}
      <div className="flex items-center justify-center space-x-4">
        {Array.from({ length: 9 }).map((_, i) => (
          <Skeleton key={i} className="h-10 w-10 rounded-full" />
        ))}
      </div>

      <Card className="w-full max-w-7xl">
        <CardContent className="space-y-6 pt-6">
          {/* Section title */}
          <Skeleton className="h-6 w-40" />

          {/* Producers */}
          <div className="space-y-2">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-10 w-full" />
          </div>

          {/* Agent Email */}
          <div className="space-y-2">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-10 w-full" />
            <Skeleton className="h-3 w-60" />
          </div>

          {/* Policy Effective Date */}
          <div className="space-y-2">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-10 w-full" />
          </div>

          {/* Carriers Checkboxes */}
          <div className="space-y-3">
            <Skeleton className="h-4 w-60" />
            <div className="flex space-x-6">
              <div className="flex items-center space-x-2">
                <Skeleton className="h-5 w-5 rounded" />
                <Skeleton className="h-4 w-20" />
              </div>
              <div className="flex items-center space-x-2">
                <Skeleton className="h-5 w-5 rounded" />
                <Skeleton className="h-4 w-20" />
              </div>
              <div className="flex items-center space-x-2">
                <Skeleton className="h-5 w-5 rounded" />
                <Skeleton className="h-4 w-20" />
              </div>
            </div>
          </div>

          {/* Footer buttons */}
          <div className="flex justify-end space-x-3">
            <Skeleton className="h-10 w-16 rounded-md" />
            <Skeleton className="h-10 w-16 rounded-md" />
            <Skeleton className="h-10 w-16 rounded-md" />
            <Skeleton className="h-10 w-24 rounded-md" />
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
